export const siteInfo = {
  name: '51吃瓜网今日吃瓜资源',
  slogan: '全网网红动态一网打尽，今日份吃瓜从这里开始',
  description: '51吃瓜网今日吃瓜资源是国内领先的网红娱乐动态聚合平台，聚焦台北娜娜、莫里秀、玩偶姐姐等热门网红人物，每日追踪全网最新人物合集与系列专题。我们覆盖热门网红的最新作品、动态更新、互动话题与粉丝讨论，为瓜友提供一站式吃瓜体验。无论是系列专题盘点、人物深度解读还是实时热点快讯，51吃瓜网都是您不可错过的吃瓜聚集地。当前热点聚焦台北娜娜最新动态、莫里秀系列连载与玩偶姐姐人物合辑。',
  stats: ['日更 50+ 最新瓜源', '覆盖 200+ 热门网红', '300 万+ 忠实瓜友'],
  cta_primary: '立即吃瓜',
  cta_secondary: '热门人物合集',
};

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '人物合集', href: '#index' },
  { label: '专题盘点', href: '#carousel' },
  { label: '热度排行', href: '#ranking' },
  { label: '吃瓜速递', href: '#cards' },
];

export const cardsData = [
  {
    id: 'card-1',
    title: '台北娜娜最新直播名场面全记录',
    summary: '台北娜娜本月直播精华全收录，高能名场面一网打尽，粉丝热议不断，速来看完整合集。',
    tag: '台北娜娜',
    tagColor: 'accent',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20modern%20streaming%20studio%20scene%20with%20warm%20lighting%20and%20fashionable%20vibes%2C%20editorial%20photography%2C%20clean%20composition%2C%20pink%20and%20orange%20accent%20tones%2C%20trendy%20atmosphere&width=800&height=500&seq=card-beijing-nana&orientation=landscape',
    date: '2026-07-28',
  },
  {
    id: 'card-2',
    title: '莫里秀连载续篇：最新剧情高能回顾',
    summary: '莫里秀连载更新至最新话，剧情转折引爆讨论区，我们整理了本周最精彩的高能片段与粉丝神评。',
    tag: '莫里秀',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20entertainment%20stage%20setting%20with%20orange%20and%20warm%20lighting%2C%20theatrical%20atmosphere%2C%20modern%20design%2C%20editorial%20photography%2C%20high%20contrast&width=800&height=500&seq=card-mori-show&orientation=landscape',
    date: '2026-07-27',
  },
  {
    id: 'card-3',
    title: '玩偶姐姐夏日限定写真全解读',
    summary: '玩偶姐姐最新夏日限定写真系列上线，每一帧都是壁纸级别，搭配独家幕后花絮与细节解读。',
    tag: '玩偶姐姐',
    tagColor: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20summer%20photoshoot%20scene%20with%20soft%20natural%20light%2C%20elegant%20composition%2C%20warm%20cream%20and%20gold%20tones%2C%20fashion%20editorial%20style%2C%20minimalist%20backdrop&width=800&height=500&seq=card-doll-sister&orientation=landscape',
    date: '2026-07-26',
  },
  {
    id: 'card-4',
    title: '三大网红本周互动全复盘',
    summary: '台北娜娜、莫里秀、玩偶姐姐本周社交互动全追踪，谁和谁的互动最甜？粉丝分析来了。',
    tag: '互动分析',
    tagColor: 'accent',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20social%20media%20content%20creation%20scene%20with%20warm%20pinkish%20lighting%2C%20modern%20digital%20lifestyle%2C%20editorial%20photography%2C%20trendy%20aesthetic&width=800&height=500&seq=card-interactions&orientation=landscape',
    date: '2026-07-25',
  },
  {
    id: 'card-5',
    title: '玩偶姐姐经典作品全系列盘点',
    summary: '从出道至今，玩偶姐姐经典作品大盘点，每一部都值得收藏，老粉新粉都必看的完整指南。',
    tag: '玩偶姐姐',
    tagColor: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=A%20retro%20nostalgic%20photo%20collection%20scene%20with%20warm%20sepia%20tones%2C%20vintage%20modern%20blend%2C%20artistic%20composition%2C%20editorial%20photography%2C%20soft%20lighting&width=800&height=500&seq=card-doll-classic&orientation=landscape',
    date: '2026-07-24',
  },
  {
    id: 'card-6',
    title: '莫里秀人物关系图谱深度解析',
    summary: '莫里秀连载人物关系越来越复杂？我们绘制了最新版人物关系图谱，一图看懂所有角色关联。',
    tag: '莫里秀',
    tagColor: 'primary',
    image: 'https://readdy.ai/api/search-image?query=A%20creative%20infographic%20style%20flowchart%20on%20a%20modern%20desk%2C%20warm%20orange%20and%20pink%20color%20scheme%2C%20editorial%20photography%2C%20clean%20minimal%20composition&width=800&height=500&seq=card-relationship&orientation=landscape',
    date: '2026-07-23',
  },
  {
    id: 'card-7',
    title: '台北娜娜粉丝见面会精彩瞬间',
    summary: '台北娜娜上周末粉丝见面会高清直击，现场互动、签名合影、限定周边一应俱全，没到场的快来看。',
    tag: '台北娜娜',
    tagColor: 'accent',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20fan%20event%20venue%20with%20warm%20ambient%20lighting%2C%20crowds%20and%20excitement%2C%20editorial%20photography%2C%20festive%20atmosphere%2C%20pink%20and%20orange%20decor&width=800&height=500&seq=card-fan-meeting&orientation=landscape',
    date: '2026-07-22',
  },
];

export const faqData = [
  {
    id: 'faq-1',
    question: '51吃瓜网更新频率是怎样的？',
    answer: '我们保持每日高频更新，平均每天推送50条以上最新网红动态与吃瓜资讯。台北娜娜、莫里秀、玩偶姐姐等重点人物有新动态时，我们会在第一时间跟进，确保瓜友不错过任何精彩内容。',
  },
  {
    id: 'faq-2',
    question: '如何快速找到特定网红的人物合集？',
    answer: '您可以通过首页的「人物合集」索引区或顶部导航栏快速定位。我们为每位热门网红设立了独立的人物合集页面，收录其全部作品、动态与相关专题盘点，方便粉丝一站式浏览。',
  },
  {
    id: 'faq-3',
    question: '51吃瓜网的内容来源是否可靠？',
    answer: '我们坚持从公开社交平台、官方发布渠道及权威娱乐媒体采集信息，所有内容均经过编辑团队核实与整理。我们不传播未经证实的谣言，力求为瓜友提供真实、准确、有料的吃瓜内容。',
  },
  {
    id: 'faq-4',
    question: '可以投稿或提供吃瓜线索吗？',
    answer: '当然可以！我们非常欢迎瓜友提供新鲜吃瓜线索和内容建议。您可以通过页面底部的「联系我们」区域找到投稿入口，编辑团队会在收到投稿后尽快审核并反馈。',
  },
];

export const mediaData = [
  {
    id: 'media-1',
    title: '台北娜娜：从素人到顶流的成长之路',
    duration: '15:28',
    cover: 'https://readdy.ai/api/search-image?query=A%20cinematic%20portrait%20style%20video%20thumbnail%20with%20warm%20dramatic%20lighting%2C%20entertainment%20documentary%20feel%2C%20pink%20and%20orange%20tones%2C%20professional%20production%20quality&width=600&height=340&seq=media-nana-journey&orientation=landscape',
    views: '128万',
  },
  {
    id: 'media-2',
    title: '莫里秀连载追更指南：入坑必看',
    duration: '22:15',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20entertainment%20series%20thumbnail%20style%2C%20theatrical%20poster%20design%2C%20warm%20orange%20lighting%2C%20cinematic%20composition%2C%20professional%20production&width=600&height=340&seq=media-mori-guide&orientation=landscape',
    views: '96万',
  },
  {
    id: 'media-3',
    title: '玩偶姐姐写真拍摄幕后花絮',
    duration: '08:42',
    cover: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20photoshoot%20scene%20with%20soft%20natural%20lighting%2C%20elegant%20minimalist%20style%2C%20cream%20and%20gold%20tones%2C%20editorial%20photography%2C%20professional%20setup&width=600&height=340&seq=media-doll-bts&orientation=landscape',
    views: '85万',
  },
  {
    id: 'media-4',
    title: '2026年上半年吃瓜大事件回顾',
    duration: '35:50',
    cover: 'https://readdy.ai/api/search-image?query=A%20year%20in%20review%20montage%20style%20thumbnail%2C%20warm%20vibrant%20colors%2C%20entertainment%20news%20collage%20aesthetic%2C%20editorial%20design%2C%20dynamic%20composition&width=600&height=340&seq=media-year-review&orientation=landscape',
    views: '210万',
  },
];

export const carouselData = [
  {
    id: 'car-1',
    title: '台北娜娜2026夏日特辑全收录',
    summary: '这个夏天台北娜娜火力全开，直播、写真、Vlog全面开花。我们整理了夏日特辑全部内容，从海边拍摄到城市探店，带你一次看遍娜娜的夏日生活。',
    tag: '热门专题',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20summer%20lifestyle%20editorial%20scene%20with%20warm%20sunset%20lighting%2C%20fashionable%20summer%20vibes%2C%20pink%20and%20orange%20tones%2C%20beachside%20atmosphere%2C%20trendy%20aesthetic%2C%20high%20quality&width=1200&height=600&seq=car-nana-summer&orientation=landscape',
  },
  {
    id: 'car-2',
    title: '莫里秀人物发展全脉络梳理',
    summary: '莫里秀连载至今已积累大量精彩内容，我们为粉丝梳理了从第一话到最新话的完整时间线，包含角色登场、关键剧情转折与伏笔解析。',
    tag: '深度盘点',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20story%20timeline%20visualization%20with%20warm%20orange%20and%20pink%20accents%2C%20editorial%20layout%20style%2C%20cinematic%20composition%2C%20professional%20design%2C%20theatrical%20atmosphere&width=1200&height=600&seq=car-mori-timeline&orientation=landscape',
  },
  {
    id: 'car-3',
    title: '玩偶姐姐合作品牌全记录',
    summary: '玩偶姐姐近年来与各大品牌的精彩合作一次看够，从美妆到服饰，从线上到线下，每一个合作都展现了不同的魅力面。',
    tag: '品牌合作',
    image: 'https://readdy.ai/api/search-image?query=A%20luxury%20fashion%20brand%20collaboration%20editorial%20scene%2C%20elegant%20minimalist%20composition%2C%20warm%20cream%20and%20gold%20lighting%2C%20high-end%20product%20photography%20style%2C%20trendy%20aesthetic&width=1200&height=600&seq=car-doll-brands&orientation=landscape',
  },
  {
    id: 'car-4',
    title: '三大网红联名企划大猜想',
    summary: '粉丝期待已久的台北娜娜x莫里秀x玩偶姐姐联名企划到底会不会来？我们整理了所有蛛丝马迹和粉丝脑洞，看看最有可能的联名方向。',
    tag: '粉丝热议',
    image: 'https://readdy.ai/api/search-image?query=A%20creative%20crossover%20collaboration%20concept%20art%20with%20three%20distinct%20visual%20styles%20blending%2C%20warm%20vibrant%20colors%2C%20editorial%20design%2C%20dynamic%20composition&width=1200&height=600&seq=car-crossover&orientation=landscape',
  },
  {
    id: 'car-5',
    title: '网红经济2026年趋势观察',
    summary: '2026年网红经济进入新阶段，我们围绕台北娜娜、莫里秀、玩偶姐姐等头部创作者，分析今年内容创作、粉丝互动与商业变现的新趋势。',
    tag: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20business%20analytics%20visualization%20with%20warm%20orange%20and%20pink%20data%20graphics%2C%20editorial%20style%2C%20professional%20composition%2C%20trendy%20corporate%20aesthetic&width=1200&height=600&seq=car-trends&orientation=landscape',
  },
  {
    id: 'car-6',
    title: '2026下半年吃瓜日历预告',
    summary: '下半年有哪些重磅吃瓜节点值得蹲守？我们整理了已知的网红动态、活动预告与行业大事，做了一份专属吃瓜日历，建议收藏。',
    tag: '吃瓜日历',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20calendar%20planner%20editorial%20scene%20with%20warm%20lighting%2C%20organized%20composition%2C%20pink%20and%20orange%20accents%2C%20modern%20minimal%20design%2C%20professional%20photography&width=1200&height=600&seq=car-calendar&orientation=landscape',
  },
];

export const indexData = [
  { id: 'idx-1', title: '台北娜娜完整合集', count: 128, icon: 'ri-user-star-line', color: 'accent' },
  { id: 'idx-2', title: '莫里秀全系列连载', count: 86, icon: 'ri-film-line', color: 'primary' },
  { id: 'idx-3', title: '玩偶姐姐写真全集', count: 95, icon: 'ri-camera-lens-line', color: 'secondary' },
  { id: 'idx-4', title: '本周热门人物动态', count: 42, icon: 'ri-fire-line', color: 'accent' },
  { id: 'idx-5', title: '月度吃瓜精选合辑', count: 67, icon: 'ri-star-line', color: 'primary' },
  { id: 'idx-6', title: '粉丝热议话题Top50', count: 50, icon: 'ri-chat-heart-line', color: 'secondary' },
  { id: 'idx-7', title: '新人网红推荐专区', count: 31, icon: 'ri-user-add-line', color: 'accent' },
  { id: 'idx-8', title: '经典名场面回顾', count: 74, icon: 'ri-history-line', color: 'primary' },
  { id: 'idx-9', title: '跨界合作全记录', count: 23, icon: 'ri-link-m', color: 'secondary' },
];

export const aboutData = {
  title: '关于51吃瓜网',
  content: '51吃瓜网今日吃瓜资源成立于2024年，是国内领先的网红娱乐动态聚合平台。我们致力于为全网吃瓜爱好者提供最及时、最全面、最有料的网红人物资讯。平台聚焦台北娜娜、莫里秀、玩偶姐姐等头部网红，覆盖人物合集、系列专题、动态盘点、粉丝互动等多元内容形态。我们相信，吃瓜不仅是一种娱乐方式，更是连接同好、分享快乐的社交体验。目前平台已积累超过300万忠实瓜友，日均内容更新50条以上，是中文互联网最具活力的吃瓜社区之一。',
  highlights: ['日更50+条最新瓜源', '覆盖200+热门网红', '300万+忠实瓜友', '专业编辑团队审核'],
};

export const commentsData = [
  {
    id: 'cmt-1',
    user: '吃瓜第一线',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimalist%20watermelon%20icon%20flat%20design%20on%20white%20background%2C%20simple%20vector%20style%2C%20green%20and%20red%20colors&width=80&height=80&seq=avatar-wm-1&orientation=squarish',
    time: '2小时前',
    content: '这个站更新太及时了，台北娜娜的最新动态每次都是第一个发的，再也不用到处找了！',
    likes: 128,
  },
  {
    id: 'cmt-2',
    user: '莫里秀铁粉',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimalist%20melon%20slice%20icon%20flat%20design%20on%20white%20background%2C%20simple%20vector%20style%2C%20pink%20and%20green%20colors&width=80&height=80&seq=avatar-wm-2&orientation=squarish',
    time: '5小时前',
    content: '莫里秀的人物关系图太有用了，之前一直搞混那几个配角关系，现在终于理清了哈哈。',
    likes: 96,
  },
  {
    id: 'cmt-3',
    user: '玩偶收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimalist%20doll%20icon%20flat%20design%20on%20white%20background%2C%20simple%20vector%20style%2C%20cream%20and%20pink%20colors&width=80&height=80&seq=avatar-wm-3&orientation=squarish',
    time: '8小时前',
    content: '玩偶姐姐的合集整理得太全面了，连早期的稀有作品都收录了，老粉感动哭。',
    likes: 75,
  },
  {
    id: 'cmt-4',
    user: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimalist%20night%20owl%20icon%20flat%20design%20on%20white%20background%2C%20simple%20vector%20style%2C%20purple%20and%20yellow%20colors&width=80&height=80&seq=avatar-wm-4&orientation=squarish',
    time: '12小时前',
    content: '每天睡前必刷一遍51吃瓜，已经成为习惯了。建议加个夜间模式，熬夜吃瓜党表示很需要。',
    likes: 63,
  },
  {
    id: 'cmt-5',
    user: '八卦研究员',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimalist%20magnifying%20glass%20icon%20flat%20design%20on%20white%20background%2C%20simple%20vector%20style%2C%20orange%20and%20pink%20colors&width=80&height=80&seq=avatar-wm-5&orientation=squarish',
    time: '1天前',
    content: '做吃瓜内容还是51专业，有专题有盘点有合集，不是那种随便转发的垃圾营销号能比的。',
    likes: 142,
  },
];

export const rankingData = [
  { id: 'rank-1', rank: 1, title: '台北娜娜夏日特辑全收录', heat: '🔥 128万', tag: '台北娜娜' },
  { id: 'rank-2', rank: 2, title: '莫里秀连载最新话高能解读', heat: '🔥 96万', tag: '莫里秀' },
  { id: 'rank-3', rank: 3, title: '玩偶姐姐限定写真全解读', heat: '🔥 85万', tag: '玩偶姐姐' },
  { id: 'rank-4', rank: 4, title: '三大网红本周互动全复盘', heat: '72万', tag: '互动分析' },
  { id: 'rank-5', rank: 5, title: '玩偶姐姐经典作品全盘点', heat: '68万', tag: '玩偶姐姐' },
  { id: 'rank-6', rank: 6, title: '莫里秀人物关系图谱解析', heat: '55万', tag: '莫里秀' },
];

export const contactData = {
  title: '联系我们',
  intro: '有吃瓜线索想投稿？有合作意向想洽谈？或者对网站有任何意见或建议？欢迎随时联系我们，编辑团队期待听到你的声音。',
  methods: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tips@51chigua.com' },
    { icon: 'ri-wechat-line', label: '官方微信', value: '51chiguawang' },
    { icon: 'ri-chat-smile-2-line', label: '官方社群', value: 'QQ群：88888888' },
  ],
};

export const topicsData = [
  { id: 'tp-1', name: '台北娜娜', count: '128条', hot: true },
  { id: 'tp-2', name: '莫里秀', count: '96条', hot: true },
  { id: 'tp-3', name: '玩偶姐姐', count: '85条', hot: true },
  { id: 'tp-4', name: '吃瓜合集', count: '67条', hot: true },
  { id: 'tp-5', name: '网红动态', count: '54条', hot: false },
  { id: 'tp-6', name: '直播名场面', count: '43条', hot: false },
  { id: 'tp-7', name: '粉丝互动', count: '38条', hot: false },
  { id: 'tp-8', name: '写真大片', count: '31条', hot: false },
  { id: 'tp-9', name: '人物关系', count: '25条', hot: false },
  { id: 'tp-10', name: '品牌合作', count: '19条', hot: false },
];

export const featuresData = [
  {
    id: 'feat-1',
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '日更50+条吃瓜内容，重点网红动态秒级追踪，让你永远快人一步吃到最新鲜的瓜。',
  },
  {
    id: 'feat-2',
    icon: 'ri-stack-line',
    title: '人物合集',
    desc: '为每位热门网红建立专属合集页面，从出道至今全作品收录，粉丝一站式浏览不迷路。',
  },
  {
    id: 'feat-3',
    icon: 'ri-team-line',
    title: '专业编辑',
    desc: '资深娱乐编辑团队审核把关，拒绝谣言和虚假内容，只提供经过核实的可靠吃瓜资讯。',
  },
  {
    id: 'feat-4',
    icon: 'ri-heart-pulse-line',
    title: '粉丝社区',
    desc: '百万瓜友聚集地，评论区互动热烈，找到同好一起讨论分享，吃瓜的快乐加倍。',
  },
];

export const appData = {
  title: '随时随地 想吃就吃',
  intro: '51吃瓜网移动端现已支持PWA安装，添加到手机桌面即可像原生App一样使用，无需下载，不占空间，随时随地追最新的瓜。',
  steps: [
    { icon: 'ri-safari-line', text: 'Safari / Chrome 打开本站' },
    { icon: 'ri-share-forward-line', text: '点击分享按钮' },
    { icon: 'ri-add-box-line', text: '选择「添加到主屏幕」' },
  ],
};

export const updatesData = [
  { id: 'upd-1', date: '07-29', time: '10:30', content: '台北娜娜发布最新夏日Vlog，海边度假与美食探店，播放量1小时破50万。', tag: '台北娜娜', tagColor: 'accent' },
  { id: 'upd-2', date: '07-29', time: '08:15', content: '莫里秀连载第86话更新，新角色登场引发粉丝热议，评论区已炸锅。', tag: '莫里秀', tagColor: 'primary' },
  { id: 'upd-3', date: '07-28', time: '22:00', content: '玩偶姐姐ins晒出新写真预告，疑似与知名美妆品牌达成合作，粉丝狂喜。', tag: '玩偶姐姐', tagColor: 'secondary' },
  { id: 'upd-4', date: '07-28', time: '16:45', content: '三大网红互动数据出炉，台北娜娜与玩偶姐姐互动量居首，莫里秀紧随其后。', tag: '互动排行', tagColor: 'accent' },
  { id: 'upd-5', date: '07-28', time: '11:20', content: '本周吃瓜精选盘点发布，涵盖直播、写真、社交互动三大板块，不容错过。', tag: '精选盘点', tagColor: 'primary' },
  { id: 'upd-6', date: '07-27', time: '19:30', content: '台北娜娜粉丝见面会精彩回顾视频上线，现场氛围感人，弹幕刷屏。', tag: '台北娜娜', tagColor: 'accent' },
  { id: 'upd-7', date: '07-27', time: '14:00', content: '莫里秀连载官方宣布下半年将有重大剧情转折，粉丝猜测纷纷。', tag: '莫里秀', tagColor: 'primary' },
  { id: 'upd-8', date: '07-26', time: '20:15', content: '玩偶姐姐限定写真集开放预约，首批5000套1小时内售罄。', tag: '玩偶姐姐', tagColor: 'secondary' },
  { id: 'upd-9', date: '07-26', time: '09:00', content: '51吃瓜网上线新版首页，优化浏览体验，新增人物合集与热度排行模块。', tag: '站内公告', tagColor: 'primary' },
];